import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { lazy, Suspense } from "react";

// Lazy load all pages for better performance and reduced initial bundle size
const Index = lazy(() => import("./pages/Index"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Charlotte = lazy(() => import("./pages/cities/Charlotte"));
const Matthews = lazy(() => import("./pages/cities/Matthews"));
const MintHill = lazy(() => import("./pages/cities/MintHill"));
const Pineville = lazy(() => import("./pages/cities/Pineville"));
const Cornelius = lazy(() => import("./pages/cities/Cornelius"));
const Huntersville = lazy(() => import("./pages/cities/Huntersville"));
const Concord = lazy(() => import("./pages/cities/Concord"));
const Gastonia = lazy(() => import("./pages/cities/Gastonia"));
const RockHill = lazy(() => import("./pages/cities/RockHill"));
const FortMill = lazy(() => import("./pages/cities/FortMill"));
const Belmont = lazy(() => import("./pages/cities/Belmont"));
const IndianTrail = lazy(() => import("./pages/cities/IndianTrail"));
const EmergencyLocksmith = lazy(() => import("./pages/EmergencyLocksmith"));
const CarKeyCopying = lazy(() => import("./pages/CarKeyCopying"));

// Loading fallback component
const PageLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-background">
    <div className="text-center">
      <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
      <p className="mt-4 text-muted-foreground">Loading...</p>
    </div>
  </div>
);

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/charlotte" element={<Charlotte />} />
              <Route path="/matthews" element={<Matthews />} />
              <Route path="/mint-hill" element={<MintHill />} />
              <Route path="/pineville" element={<Pineville />} />
              <Route path="/cornelius" element={<Cornelius />} />
              <Route path="/huntersville" element={<Huntersville />} />
              <Route path="/concord" element={<Concord />} />
              <Route path="/gastonia" element={<Gastonia />} />
              <Route path="/rock-hill" element={<RockHill />} />
              <Route path="/fort-mill" element={<FortMill />} />
              <Route path="/belmont" element={<Belmont />} />
              <Route path="/indian-trail" element={<IndianTrail />} />
              <Route path="/Emergency-Locksmith" element={<EmergencyLocksmith />} />
              <Route path="/Car-Key-Copying" element={<CarKeyCopying />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
